import QueryParameter from '@/models/QueryParameter'

export default class QueryParameterRepo {
	static endpoint = '/api/query-parameter'

	static async create (apiQueryParameters: Array<any>) {
		await QueryParameter.api().post(this.endpoint, apiQueryParameters)
	}
}
